const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_1001_32508)">
      <path
        d="M5.52734 5.02539H6.46484V8.77539H5.52734V5.02539Z"
        fill="#555555"
      />
      <path
        d="M5.99922 4.12539C6.26846 4.12539 6.48672 3.90713 6.48672 3.63789C6.48672 3.36865 6.26846 3.15039 5.99922 3.15039C5.72998 3.15039 5.51172 3.36865 5.51172 3.63789C5.51172 3.90713 5.72998 4.12539 5.99922 4.12539Z"
        fill="#555555"
      />
      <path
        d="M6 0.375706C4.4593 0.329172 2.96292 0.894942 1.83841 1.94917C0.713894 3.0034 0.0528597 4.46021 0 6.00071C0.0528597 7.5412 0.713894 8.99801 1.83841 10.0522C2.96292 11.1065 4.4593 11.6722 6 11.6257C7.5407 11.6722 9.03708 11.1065 10.1616 10.0522C11.2861 8.99801 11.9471 7.5412 12 6.00071C11.9471 4.46021 11.2861 3.0034 10.1616 1.94917C9.03708 0.894942 7.5407 0.329172 6 0.375706ZM6 10.6882C4.70788 10.7349 3.44986 10.2679 2.50113 9.38948C1.5524 8.51103 0.9902 7.2926 0.9375 6.00071C0.9902 4.70882 1.5524 3.49038 2.50113 2.61193C3.44986 1.73348 4.70788 1.26652 6 1.31321C7.29212 1.26652 8.55014 1.73348 9.49887 2.61193C10.4476 3.49038 11.0098 4.70882 11.0625 6.00071C11.0098 7.2926 10.4476 8.51103 9.49887 9.38948C8.55014 10.2679 7.29212 10.7349 6 10.6882Z"
        fill="#555555"
      />
    </g>
    <defs>
      <clipPath id="clip0_1001_32508">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoIcon;
